// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3logR","label":"SetPasswdForm_label__3F-Db"};